import React, { useState, useEffect } from "react";
import { Routes, Route, Switch, withRouter } from "react-router-dom";
import request from "request"
import Terminal from "lib/auth/Terminal"

import CustomAmountModal from "./CustomAmountModal"

import Form from "Form"
import Input from "Input"
import Button from "Button"

import ProductListView from "./ProductListView"
import ProductGridView from "./ProductGridView"

import DiscountListView from "./DiscountListView"
import OrderListView from "./OrderListView"
import RefundOrderListView from "./RefundOrderListView"

const ItemsList = ({
  terminal,
  store,
  orderId,
  selectTab,
  tabCount,
  selectProduct,
  addProduct,
  quickAddDiscount,
  quickAddGratuity,
  currentView,
  switchViewFor,
  isModifyingOrder}) => {
  const [ isLoaded, setIsLoaded ] = useState(false)
  const [ isCustomAmountOpen, setIsCustomAmountOpen ] = useState(false)
  const [ categories, setCategories ] = useState([])
  const [ products, setProducts ] = useState([])
  const [ discounts, setDiscounts ] = useState([])
  const [ gratuities, setGratuities ] = useState([])
  const [ orders, setOrders ] = useState([])

  const fetchMenu = () => {
    setIsLoaded(false)
    const req = request.get(`/menus/${store.id}`)
    req.then(({data}) => {
      setCategories(data.categories)
      setProducts(data.products)
      setDiscounts(data.discounts)
      setGratuities(data.gratuities || [])
      setOrders(data.orders)
      setIsLoaded(true)
    })
  }

  useEffect(fetchMenu, [tabCount])

  const quickAddProduct = (productId) => addProduct(productId, 1, [])

  const quickAddDiscountAndSwitchToProducts = (discountId) => {
    quickAddDiscount(discountId).then(() => {
      switchView();
    })
  }

  const quickAddGratuityAndSwitchToProducts = (gratuityId) => {
    quickAddGratuity(gratuityId).then(() => {
      switchView();
    })
  }

  const switchView = switchViewFor("product")

  return(
    <div className="MenuWrapper is-flex is-flex-direction-column pt-4">
      <div className="is-flex">
        <Button
          onClick={fetchMenu}
          loading={!isLoaded || isModifyingOrder}
          text="Refresh"
        />

        <Button
          className="ml-4"
          onClick={switchView}
          text={`${currentView === "list" ? "Grid" : "List" } View`}
        />

        <Button
          className="ml-4"
          color={`${currentView === "discount-list" ? "is-active" : ""}`}
          onClick={switchViewFor("discount-list")}
          text="Discounts"
        />

        <Button
          className="ml-4"
          color={`${currentView === "tabs-list" ? "is-active" : ""}`}
          onClick={switchViewFor("tabs-list")}
          text="Tabs"
        />

        { terminal?.terminalRefundsEnabled && (
          <Button
            className="ml-4"
            color={`${currentView === "refunds-list" ? "is-active" : ""}`}
            onClick={switchViewFor("refunds-list")}
            text="Refund"
          />
        )}

        <Button
          className="ml-auto is-outlined has-text-weight-bold"
          color="link"
          loading={!isLoaded || isModifyingOrder}
          onClick={() => setIsCustomAmountOpen(true)}
          text="Add Custom Amount"
        />
      </div>

      { currentView === "list" &&
        <ProductListView
          products={products}
          categories={categories}
          selectProduct={selectProduct}
          quickAddProduct={quickAddProduct}
          isModifyingOrder={isModifyingOrder}
        />
      }

      { currentView === "grid" &&
        <ProductGridView
          products={products}
          categories={categories}
          selectProduct={selectProduct}
          isModifyingOrder={isModifyingOrder}
        />
      }

      { currentView === "discount-list" &&
        <DiscountListView
          discounts={discounts}
          gratuities={gratuities}
          quickAddDiscount={quickAddDiscountAndSwitchToProducts}
          quickAddGratuity={quickAddGratuityAndSwitchToProducts}
          isModifyingOrder={isModifyingOrder}
        />
      }

      { currentView === "tabs-list" &&
        <OrderListView
          orders={orders}
          orderId={orderId}
          selectTab={selectTab}
          tabCount={tabCount}
          isModifyingOrder={isModifyingOrder}
        />
      }

      { currentView === "refunds-list" && terminal?.terminalRefundsEnabled &&
        <RefundOrderListView
          terminal={terminal}
        />
      }

      <CustomAmountModal
        terminal={terminal}
        addProduct={addProduct}
        isOpen={isCustomAmountOpen}
        setIsOpen={setIsCustomAmountOpen}
      />
    </div>
  )
}

export default ItemsList
